import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { ticketPriorityContext, ticketPrioritySchema } from './TicketPriorityContext';
import { TicketPriorityForm } from './components';


let NewTicket = () => {
    let { isLoading, saveticketPriority, ticketPriority } = useContext(ticketPriorityContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="Ticket Priority"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={ticketPrioritySchema}
                    initialValues={ticketPriority}
                    onSubmit={(values, action) => {
                        saveticketPriority(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <TicketPriorityForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default NewTicket;